import React from "react";
import {withNamespaces} from "react-i18next";
import {Button, ButtonGroup} from "react-bootstrap";
import {connect} from "react-redux";
import {networkDeviceActions} from "../actions/network-device.actions";
import {modalActions} from "../actions/modal.actions";

const IgnoreScheduleModeButton = ({t, size = "", networkDevice, reloadSimpleModel = false,  showModal, hideModal, setIgnoreSchedule}) => {

    const openConfirmModal = (id, val) => {
        showModal({
            open: true,
            title: t('are-you-sure'),
            message: `<p>${t('msg.change-ignore-schedule-msg')}</p></p>`,
            confirmLabel: t('OK'),
            confirmIcon: 'fa-check-circle',
            classNameBtnConfirm: 'btn-info',
            dataId: id,
            confirmAction: (id) => {
                setIgnoreSchedule(id, val);
                hideModal();
            },
            closeModal: closeModal,
        }, 'confirm')
    };

    const closeModal = () => {
        hideModal()
    };
    return (
        <div>
            <span> {t('ignore-schedule')} </span> &nbsp;
            <ButtonGroup size={size} className="mx-0 my-1">
                <Button variant={ networkDevice.ignoreSchedule ? 'outline-danger' : 'outline-secondary'}
                        active={ networkDevice.ignoreSchedule }
                        onClick={() => openConfirmModal(networkDevice.id, !networkDevice.ignoreSchedule) }>
                    {t('on')}
                </Button>
                <Button variant={'outline-secondary'}
                        active={ !networkDevice.ignoreSchedule }
                        onClick={() => openConfirmModal(networkDevice.id, !networkDevice.ignoreSchedule) }>
                    {t('off')}
                </Button>
            </ButtonGroup>
        </div>
    )
};

const mapDispatchToProps = dispatch => ({
    setIgnoreSchedule: (id, val, reload) => dispatch(networkDeviceActions.setIgnoreSchedule(id, val, reload)),
    hideModal: () => dispatch(modalActions.hideModal()),
    showModal: (modalProps, modalType) => {
        dispatch(modalActions.showModal({ modalProps, modalType }))
    }
});


export default withNamespaces()(connect(null, mapDispatchToProps)(IgnoreScheduleModeButton));
